import React, { FC } from 'react'

interface Props {
  width?: string | number
  height?: string | number
  className?: string
}

export const CheckBoxCheckedGreen: FC<Props> = ({
  width = 17,
  height = 16,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="16" height="16" rx="4" fill="#12B76A" />
      <path
        d="M12.5 5L7 10.5L4.5 8"
        stroke="white"
        strokeWidth="1.6666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
